import { Link } from "react-router-dom";
import { Plane, Building2, CalendarClock, AlertTriangle, ArrowRight, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/services";

const ICONS = { Plane, Building2, CalendarClock, AlertTriangle };

export default function Services() {
  return (
    <div>
      <section className="bg-brand-navy text-white grain">
        <div className="max-w-7xl mx-auto px-6 py-20">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.25em] text-brand-gold font-bold mb-3">Immigration &amp; legal services</p>
            <h1 className="font-serif text-5xl md:text-6xl tracking-tight max-w-3xl">Compliant Vietnam services, tailored to your goals</h1>
            <p className="mt-5 text-slate-300 text-lg max-w-2xl">Each service is prepared strictly in accordance with Vietnam Immigration Department requirements and current government regulations.</p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-20 space-y-8">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon] || Plane;
          return (
            <Reveal key={s.key} delay={i * 0.06}>
              <div className="grid md:grid-cols-12 gap-8 items-center bg-white rounded-3xl border border-slate-200 overflow-hidden hover:shadow-soft transition-shadow">
                <div className={`md:col-span-5 h-60 md:h-full ${i % 2 ? "md:order-2" : ""}`}>
                  <img src={s.hero} alt={s.title} className="w-full h-full object-cover min-h-[240px]" />
                </div>
                <div className="md:col-span-7 p-8 md:p-10">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-11 h-11 rounded-xl bg-brand-red/10 flex items-center justify-center text-brand-red"><Icon className="w-5 h-5" /></div>
                    <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500"><Clock className="w-3.5 h-3.5" /> {s.processing}</span>
                  </div>
                  <h2 className="font-serif text-3xl md:text-4xl text-brand-navy tracking-tight">{s.title}</h2>
                  <p className="mt-3 text-slate-600 leading-relaxed">{s.short}</p>
                  <ul className="mt-5 grid sm:grid-cols-2 gap-2">
                    {s.features.map((f) => (
                      <li key={f} className="flex items-start gap-2 text-sm text-slate-600">
                        <span className="w-1.5 h-1.5 rounded-full bg-brand-gold mt-2 shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-7 flex flex-wrap gap-3">
                    <Link to={`/services/${s.slug}`} data-testid={`services-detail-${s.key}`}
                      className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-navy text-white font-semibold hover:bg-slate-800 transition-colors">
                      Full details <ArrowRight className="w-4 h-4" />
                    </Link>
                    <Link to={`/apply/${s.slug}`} data-testid={`services-apply-${s.key}`}
                      className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-brand-red text-white font-semibold hover:bg-brand-reddark transition-colors shadow-redglow">
                      Apply now
                    </Link>
                  </div>
                </div>
              </div>
            </Reveal>
          );
        })}
      </section>
    </div>
  );
}
